import log from "loglevel";
import { GetStaticProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import { ChefsPage } from "@/components/pages/chefs/ChefsPage";

export default ChefsPage;

export const getStaticProps: GetStaticProps = async context => {
  try {
    return {
      props: {
        ...(await serverSideTranslations(context.locale as string, [
          "common",
          "chefspage",
          "more-drawer",
          "faq",
          "errors"
        ]))
      }
    };
  } catch (e) {
    log.error("%0", e);

    return {
      props: {
        notFound: true
      }
    };
  }
};
